/**
 * Created by ah on 04/01/17.
 */
import _ from 'lodash';
import * as Immutable from "immutable";
import moment from 'moment';
import {createReducer} from 'redux-create-reducer';
import {Keys, Actions} from '../constants';
import {standardLoadingReducerFactory} from './reducer-utils';
import {toImmutable } from '../../utils'
import {Looklet} from '../constants/looklet';

function getCompletionScore(state) {
    switch (state) {
        case Looklet.ViewState.PRE_PROCESSING_CHECK_OUT:
            return 0;
        case Looklet.ViewState.AWAITING_RETOUCH:
            return 1;
        case Looklet.ViewState.RETOUCH_CHECK_OUT:
        case Looklet.ViewState.RECALLED:
            return 2;
        case Looklet.ViewState.COMPLETED:
            return 3;
        case Looklet.ViewState.REJECTED_RETOUCH:
            return 4;
        case Looklet.ViewState.APPROVED:
            return 5;
        default: return 0
    }
}
const transformView = (attrs) => {
    return {
        id:attrs.id,
        state:attrs.state,
        type:attrs.type || Looklet.ViewType.VIEW,
        score:1,
        hasComplement:attrs.complement,
        completionScore:getCompletionScore(attrs.state),
    };

};
const transformDisplay = (attrs) => {
    return {
        id:attrs.id,
        state:attrs.state,
        type:attrs.type || Looklet.DisplayType.FABRIC_DETAIL,
        score:1,
        hasComplement:attrs.complement,
        completionScore:getCompletionScore(attrs.state),
    };

};

const transformItem = (attrs) => {
    let views = _.flatten(
        _.map(
            attrs.variants, function(variant) {

                return variant.views;
            }
        )
    );
    let displays = attrs.displays;
    const displayGhost = _.some(
        displays, function(d) {
            return d.type === Looklet.DisplayType.GHOST;

        }
    );
    views = views.map( transformView);
    const ghosts = _.filter(
        views, function(v) {
            return v.hasComplement;
        }
    ).length;
    // QuickFix to get complement as ghost
    const ghostCount = ghosts.length || displayGhost ? 1 : 0;
    if ( ghosts.length===0 && displayGhost) {
        displays.push(ghosts[0].complement);
    }
    displays = displays.map(transformDisplay);
    const viewCompletionScore = _.reduce(views, function(memo, a) { return memo + a.completionScore}, 0);
    const displayCompletionScore = _.reduce(displays, function(memo, a) { return memo + a.completionScore}, 0);
    //attrs.publishDate = moment().add(Math.random() * 380 - 10, 'minutes');
    return {
        [Keys.ID]:attrs.id,
        [Keys.Item.PUBLISH_DATE]:attrs.publishDate?moment.utc(attrs.publishDate):null,
        [Keys.Item.VIEWS]:views,
        [Keys.Item.DISPLAYS]:displays,
        [Keys.Item.CATEGORY]:attrs.category,
        [Keys.Item.CUSTOMER]:attrs.customer,
        [Keys.Item.ASSIGNEE_ID]: attrs.assigneeId,
        [Keys.Item.QC_ASSIGNEE_ID]: attrs.qcAssigneeId,
        [Keys.Item.HIDDEN]:!!attrs.hidden,
        [Keys.Item.PREVIEW_URL]:'http://' + attrs.smallImage,
        // TODO: Make correct
        [Keys.Item.VIEW_COUNT]:views.length,
        [Keys.Item.DISPLAY_COUNT]:displays.length-ghostCount,
        [Keys.Item.GHOST_COUNT]:ghostCount,
        [Keys.Item.COMPLETION_SCORE]: (viewCompletionScore+displayCompletionScore)/(views.length+displays.length),
        [Keys.Item.DIFFICULTY_TAGS]:{}
    }
};
/**
 * Transforms dto format to internal and overlays original items
 * @param items
 * @param originalItems
 */
function transformAndMergeEachItem(items, originalItems) {
    let result = {};
    items.forEach(i => {
       result[i[Keys.ID]]=transformItem(i);
    });
    // This need to be tested; TODO test
    return originalItems.merge(toImmutable(result));
}
function updateInWorkSession(items, workSessionItemIds) {
    return items.map((item, id) => item.set(Keys.Item.IN_WORK_SESSION, workSessionItemIds.contains(id)));
}
function updateItemStateFromSuccess(itemsState, action, isSearch) {
    const originalItems = itemsState.get([Keys.StoreSliceData.ITEMS], Immutable.Map());
    const newItems = action.payload[Keys.StoreSliceData.ITEMS];
    // if we are in current work session, update the new items to reflect that
    const workSessionItemIds = action.currentWorkSession.get(Keys.CurrentWorkSession.ITEMS,Immutable.Set());
    const mergedItems = updateInWorkSession(
        transformAndMergeEachItem(newItems,originalItems),
        workSessionItemIds
    );
    const newItemIds = Immutable.Set(newItems.map((i) => i.id));

    const mergedState =  itemsState.merge({
        loading: false,
        loadingFailed: false,
        [Keys.StoreSliceData.ITEMS]: mergedItems,
        lastLoadSuccess: moment()
    });
    return isSearch?mergedState.merge({searchItemsIds: Immutable.Set(newItems.map((i) => i.id))}):mergedState;
}
export default createReducer(
    {},
    Object.assign({},
        standardLoadingReducerFactory(Actions.GET_ITEMS, Keys.StoreSliceData.ITEMS, transformAndMergeEachItem),
        {
            // Get items
            [Actions.GET_ITEMS + '_REQUEST'](itemsState, action) {

                return itemsState.merge({loading: true, loadingFailed: false});
            },
            [Actions.GET_ITEMS + '_SUCCESS'](itemsState, action) {
                return updateItemStateFromSuccess(itemsState, action ,false)
            },
            [Actions.GET_ITEMS + '_FAILURE'](state, action) {
                return state.merge({loading: false, loadingFailed: true, errorMessage: action.payload.message});
            },

            // Search items
            [Actions.GET_SEARCH_ITEMS + '_REQUEST'](itemsState, action) {

                return itemsState.merge({loading: true, loadingFailed: false});
            },
            [Actions.GET_SEARCH_ITEMS + '_SUCCESS'](itemsState, action) {
                return updateItemStateFromSuccess(itemsState, action ,true)
            },
            [Actions.GET_SEARCH_ITEMS + '_FAILURE'](state, action) {
                return state.merge({loading: false, loadingFailed: true, errorMessage: action.payload.message});
            },
        },         {
            [Actions.CURRENT_WORK_SESSION_UPDATED]:(itemsState, action) => {
                // synchronize current session items
                const currentWorkSession = action.payload[[Keys.StoreSliceData.CURRENT_WORK_SESSION]];
                const itemsInSession = currentWorkSession.get(Keys.CurrentWorkSession.ITEMS, Immutable.Set());
                return itemsState.updateIn([Keys.StoreSliceData.ITEMS], (itemsMap) => {
                    return itemsMap.map((item, id) => {
                        return item.set(Keys.Item.IN_WORK_SESSION, itemsInSession.contains(id));
                    })
                })
            }
        }
    )
);




// WEBPACK FOOTER //
// ./src/model/reducers/item-reducer.js